import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('itw_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Dedicated admin client (separate token so it never clashes with customer auth)
export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('itw_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// SSE streaming helper for the AI assistant using fetch + ReadableStream
export async function streamChat({ sessionId, message, language, onDelta, onSession, onError, onDone }) {
  try {
    const res = await fetch(`${API}/ai/chat`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId, message, language }),
    });
    if (!res.ok || !res.body) {
      onError && onError('network');
      onDone && onDone();
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split('\n\n');
      buffer = parts.pop() || '';
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith('data:')) continue;
        const payload = line.slice(5).trim();
        if (payload === '[DONE]') { onDone && onDone(); return; }
        try {
          const obj = JSON.parse(payload);
          if (obj.session_id && onSession) onSession(obj.session_id);
          if (obj.delta && onDelta) onDelta(obj.delta);
          if (obj.error && onError) onError(obj.error);
        } catch (e) { /* ignore */ }
      }
    }
    onDone && onDone();
  } catch (e) {
    onError && onError('network');
    onDone && onDone();
  }
}
